import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { toJS } from 'immutable';
import TIFFRecommendAnExchange from "../../Components/TIFFRecommendAnExchange";
import {
  switchTabExchange,
  setPathFromTIFF,
  fetchCustomPoolFee
} from "../../../RecommendFlow/actions";
import {
  setExchangeIntoTiff,
  setStepOne,
  selectTiffOption,
  setStepTwo,
  submitTiffForm,
  getTiffFormInfo,
  getTiffDisclaimer,
  fetchPoolData,
  fetchUnderlyingFunds,
  setPoolModalFalse,
  resetFlow,
  submitUpdateTiff,
  resetInitialFlow,
  fetchAccountDataTiff,
  fetchAllPoolDataFrom,
  getExpectedExchangeDate,
  submitFormData,
  disableFrom,
  valueInFormChange,
  formDrupalContent,
  submitDataSuccess,
  submitDataError
} from "./actions";
import { TiffRecommendAnExchangeDerivedStates } from "./selectors";

export const mapStateToProps = state => ({
  accDataPools: state.getIn(["tiffExchange", "accountData", "data"]),
  ...TiffRecommendAnExchangeDerivedStates(state.toJS())
});

export const mapDispatchToProps = dispatch => ({
  tabExchange: key => {
    dispatch(switchTabExchange(key));
    dispatch(setPathFromTIFF(key));
  },
  setExchangeIntoTiff: data => dispatch(setExchangeIntoTiff(data)),
  setStepOne: data => dispatch(setStepOne(data)),
  setStepTwo: data => dispatch(setStepTwo(data)),
  selectTiffOption: data => dispatch(selectTiffOption(data)),
  submitTiffForm: data => dispatch(submitTiffForm(data)),
  getTiffFormInfo: data => dispatch(getTiffFormInfo(data)),
  getTiffDisclaimer: data => dispatch(getTiffDisclaimer(data)),
  requestPoolData: data => dispatch(fetchPoolData(data)),
  requestunderlyingFunds: data => dispatch(fetchUnderlyingFunds(data)),
  setPoolModalFalse: data => dispatch(setPoolModalFalse(data)),
  resetFlow: () => dispatch(resetFlow()),
  fetchCustomPoolFee: (data) => dispatch(fetchCustomPoolFee(data)),

  resetInitialFlow: () => dispatch(resetInitialFlow()),
  submitUpdateTiff: data => dispatch(submitUpdateTiff(data)),
  requestAllPoolDataTiff: data => dispatch(fetchAllPoolDataFrom(data)),
  requestDataTiff: data => dispatch(fetchAccountDataTiff(data)),
  getExchangeDate: data => dispatch(getExpectedExchangeDate(data)),
  submitData: data => dispatch(submitFormData(data)),
  submitDataSuccess: data => dispatch(submitDataSuccess(data)),
  submitDataError: data => dispatch(submitDataError(data)),
  disableFrom: data => dispatch(disableFrom(data)),
  valueInFormChange: data => dispatch(valueInFormChange(data)),
  formDrupalContent: data => dispatch(formDrupalContent(data)),
});

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(TIFFRecommendAnExchange));
